import { useAuth } from '@/features/auth';
import { UserType } from '@/shared/constants/auth/auth.constant.ts';
import { useMyGroups } from '../api/use-business.query';

/**
 * 기업 콘솔 접근 판정 — 단일 진실원천.
 *
 * 접근 = (계정 자체가 사업자: UserType.BUSINESS) OR (조직 ACTIVE 멤버십 보유).
 *
 * 왜 UserType 단독이 아니라 멤버십인가:
 *  - 초대받아 합류한 개인(INDIVIDUAL) 도 조직 콘솔에 들어와야 한다.
 *  - 반대로 조직을 나가면(멤버십 LEFT) 콘솔 접근은 자동 회수된다 —
 *    UserType 을 건드리지 않으므로 정체성/데이터 정합이 깨지지 않는다.
 *  - 실제 권한(무엇을 할 수 있는가)은 서버 OrgPermission(OWNER/ADMIN/…)이
 *    최종 판정한다. 이 훅은 콘솔 '진입' UI 게이팅 전용.
 *
 * 사업자 계정은 멤버십 조회 결과를 기다리지 않고 즉시 통과시켜 깜빡임을 줄인다.
 */
export function useOrgAccess() {
  const { user, loading: authLoading } = useAuth();
  const isBusinessAccount = user?.userType === UserType.BUSINESS;

  // myGroups 는 ACTIVE 멤버십만 반환한다(REQUESTED 는 UserType.BUSINESS 라 위에서 커버).
  const { data: memberships, isLoading: membershipsLoading } = useMyGroups();
  const hasMembership = (memberships?.length ?? 0) > 0;

  // 사업자 계정이면 멤버십 로딩을 기다릴 필요 없음.
  const loading = authLoading || (!isBusinessAccount && membershipsLoading);

  return {
    hasAccess: isBusinessAccount || hasMembership,
    loading,
    isBusinessAccount,
    hasMembership,
  };
}
